<!-- quote-preview-v2.component.html -->
<!-- Design pro inspiré Uniswap : Clean, focus sur received amount + provider. Dépliable pour détails. Mobile-first. -->
<div class="quote-preview-v3" [class.mobile]="true"> <!-- md:hidden pour mobile comme original -->
  <!-- Header principal : Inspiré Uniswap (Provider + Received Amount + Rate) -->
  <div class="header-section">
    <div class="provider-row">
      <img *ngIf="providerLogo" [src]="providerLogo" alt="Provider" class="provider-logo" />
      <span class="provider-name">{{ providerName }}</span>
    </div>
    <div class="received-amount">
      <div class="amount-primary">{{ estimatedReceived }} <span *ngIf="estimatedReceivedFiat" class="amount-fiat">{{ estimatedReceivedFiat }}</span></div>
      
    </div>
    <div class="exchange-rate">{{ exchangeRate }}</div>
  </div>

  <!-- Bouton déplier détails (comme Uniswap : "Details" chevron) -->
  <button class="details-toggle" (click)="toggleDetails()">
    <span>{{ 'DETAILS' | translate }}</span>
    <svg class="chevron" [attr.data-open]="showDetails" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Détails dépliables : Inspiré Uniswap (fees, network, slippage avec placeholders) -->
  <div class="details-section" *ngIf="showDetails">
    <!--<div class="detail-row">
      <span class="label">{{ 'ROUTE_FEE' | translate }}</span>
      <span class="value">{{ routeFee }}</span>
    </div>
    <div class="detail-row">
      <span class="label">{{ 'NETWORK_COST' | translate }}</span>
      <span class="value">{{ networkCost }}</span>
    </div>-->
    <div class="detail-row">
      <span class="label">{{ 'PRICE_IMPACT' | translate }}</span>
      <span class="value">{{ priceImpact }}</span>
    </div>
    <div class="detail-row">
      <span class="label">{{ 'MAX_SLIPPAGE' | translate }}</span>
      <span class="value">{{ maxSlippage }}</span>
    </div>
    <div class="detail-row">
  <span class="label">{{ 'NETWORK_FEE' | translate }}</span>
  <span class="value">
    {{ mainFee.textEth || '—' }}
    <ng-container *ngIf="mainFee.textFiat"> ({{ mainFee.textFiat }}) </ng-container>
  </span>
</div>
  </div>

  <!-- Statut (réutilisé, centré comme Uniswap) -->
  <div class="status-section" *ngIf="swapStatus !== 'idle'">
    <div *ngIf="swapStatus === 'approve'" class="status approve">🔐 {{ 'APPROVE_PENDING' | translate }}</div>
    <div *ngIf="swapStatus === 'pending'" class="status pending">⏳ {{ 'SWAP_PENDING' | translate }}</div>
    <div *ngIf="swapStatus === 'success'" class="status success">
      ✅ {{ 'SWAP_SUCCESS' | translate }} <a [href]="'https://etherscan.io/tx/' + swapHash" target="_blank">{{ swapHash | slice:0:10 }}...</a>
    </div>
    <div *ngIf="swapStatus === 'error'" class="status error">{{ getFormattedSwapError(swapError) }}</div>
  </div>

  <!-- Barre d’actions (compact) -->
<div class="mt-4 flex justify-between items-stretch gap-3">
  <!-- Share (compact) -->
  <button type="button"
          (click)="onShareClick()"
          class="flex-1 rounded-xl px-3 py-2 border hover:shadow-sm transition
           bg-white text-blue-700 border-blue-200 text-sm
           dark:bg-transparent dark:text-blue-300 dark:border-blue-500/30">
    <div class="flex items-center justify-center gap-2 font-semibold">
      <img src="assets/icons/share-envelope.png" class="h-4 w-auto" alt="Share" />
      <span>{{ 'SHARE' | translate }}</span>
    </div>
  </button>

  <!-- Validate (compact) -->
  <button type="button"
          [disabled]="swapDisabled || !quote"
          (click)="!swapDisabled && quote && executeRequest.emit()"
          class="flex-1 rounded-xl px-3 py-2 border transition
           bg-white border-green-200 text-green-700 text-sm
           enabled:hover:shadow-sm enabled:hover:ring-2 enabled:hover:ring-green-300
           disabled:opacity-40 disabled:cursor-not-allowed
           dark:bg-transparent dark:text-green-300 dark:border-green-500/30">
    <div class="flex items-center justify-center gap-2 font-semibold">
      <img src="assets/icons/validate-checkmark.png" class="h-4 w-auto" alt="Validate" />
      <span>{{ 'VALIDATE' | translate }}</span>
    </div>
  </button>
</div>
<!-- Alternatives : ligne compacte (provider à gauche, bouton Details à droite),
     puis un second bloc dépliable en pleine largeur sous la ligne -->
<div *ngIf="otherRoutes.length > 0" class="alternatives-section">

  <button
  class="alternatives-toggle
         text-purple-600 bg-purple-600/10 border border-purple-600/25
         hover:bg-purple-600/15 hover:border-purple-600/40
         dark:text-violet-300 dark:bg-purple-600/15 dark:border-violet-400/40"
  (click)="toggleAlternatives()">
  <span>{{ otherRoutes.length }} {{ 'ALTERNATIVES' | translate }}</span>
  <svg class="chevron" [attr.data-open]="showAlternatives" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
  </svg>
</button>

  
  <div class="alternatives-list" *ngIf="showAlternatives">
  <ng-container *ngFor="let r of otherRoutes; trackBy: keyOf">
    <div
      class="alternative-item"
      [class.selected]="isAltSelected(r)"
      style="display:flex; flex-direction:column; gap:10px; width:100%;">

      <!-- 1) Ligne : logo + nom à gauche, bouton Détails à droite -->
      <div
        class="grid items-center gap-2
               md:[grid-template-columns:minmax(140px,220px)_minmax(0,1fr)_max-content]"
        style="
          /* Mobile: 2 colonnes -> (contenu) | (bouton) */
          display:grid; grid-template-columns:minmax(0,1fr) max-content;
          grid-auto-rows:auto;
          align-items:center; width:100%;
        ">

        <!-- Provider : mobile (col 1 / row 1) | desktop (col 1) -->
        <div class="md:col-start-1"
             style="grid-column:1; grid-row:1; display:flex; align-items:center; gap:8px; min-width:0; max-width:220px;">
          <img *ngIf="getRouteLogo(r)" [src]="getRouteLogo(r)"
               style="width:22px; height:22px; border-radius:9999px;" />
          <span style="font-weight:600; font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
            {{ getRouteProvider(r) }}
          </span>
        </div>

        <!-- Montant + Fiat : mobile (ligne 2, span 2 colonnes) | desktop (col 2) -->
        <div class="md:col-start-2 md:justify-self-center md:text-center md:block"
             style="
               grid-column:1 / span 2;  /* <-- prend toute la ligne en mobile */
               grid-row:2;
               justify-self:start; text-align:left;
               display:flex; align-items:baseline; gap:8px; white-space:nowrap;
               min-width:0; max-width:100%; overflow:hidden; text-overflow:ellipsis;">
          <span style="font-weight:600; font-size:13px; line-height:1.1;">
            {{ getRouteEstimatedBuy(r) }}
          </span>
          <span *ngIf="getRouteEstimatedBuyFiat(r)"
                class="md:block"
                style="font-size:11px; opacity:.7; line-height:1.1;">
            {{ getRouteEstimatedBuyFiat(r) }}
          </span>
        </div>

        <!-- Bouton DETAILS : mobile (ligne 1, col 2) | desktop (col 3) -->
        <button class="md:col-start-3"
                (click)="toggleAltDetails(r)"
                style="
                  grid-column:2;  /* reste à droite en mobile */
                  grid-row:1;     /* <-- ne span plus 2 lignes */
                  justify-self:end;
                  display:flex; align-items:center; gap:6px;
                  padding:6px 10px; border-radius:12px; border:1px solid rgba(0,0,0,.06);
                  font-size:11px; white-space:nowrap;
                ">
          <span>{{ 'DETAILS' | translate }}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               style="width:16px; height:16px; transition:transform .2s;"
               [style.transform]="isAltExpanded(r) ? 'rotate(180deg)' : 'rotate(0deg)'">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
      </div>

    </div>

    <!-- 2) Panneau détails : même largeur, SOUS la ligne -->
    <div class="alt-details-panel" *ngIf="isAltExpanded(r)"
         style="width:100%; margin-top:6px;">
      <div class="details-section"
           style="border:1px solid rgba(0,0,0,0.06); border-radius:16px; padding:12px 14px;">

        <div class="detail-row" style="display:flex; justify-content:space-between; margin:6px 0;">
          <span class="label">{{ 'PRICE_IMPACT' | translate }}</span>
          <span class="value">{{ getRoutePriceImpact(r) }}</span>
        </div>
        <div class="detail-row" style="display:flex; justify-content:space-between; margin:6px 0;">
          <span class="label">{{ 'MAX_SLIPPAGE' | translate }}</span>
          <span class="value">{{ getRouteMaxSlippage(r) }}</span>
        </div>
        <div class="detail-row" style="display:flex; justify-content:space-between; margin:6px 0;">
          <span class="label">{{ 'NETWORK_FEE' | translate }}</span>
          <span class="value">
            {{ getRouteDisplayedGasFee(r).textEth }}
            <span>({{ getRouteDisplayedGasFee(r).textFiat }})</span>
          </span>
        </div>

        <div class="alt-validate-row" style="display:flex; justify-content:flex-end; margin-top:10px;">
          <button *ngIf="!isAltSelected(r); else altSelected"
                  type="button"
                  (click)="onValidateAlternative(r)"
                  [disabled]="isAlternativeDisabled(r)"
                  class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium
                             bg-green-600/90 text-white border-green-600
                             hover:opacity-90
                             disabled:bg-transparent disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed">
            <svg class="w-3 h-3"
                 [ngClass]="{ 'text-white': !isAlternativeDisabled(r), 'text-gray-400': isAlternativeDisabled(r) }"
                 viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
            </svg>
            {{ 'VALIDATE' | translate }}
          </button>

          <ng-template #altSelected>
            <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md
                         border border-green-500/60 bg-green-50 text-green-700
                         text-xs font-medium">
              <svg class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                      clip-rule="evenodd" />
              </svg>
              {{ 'COMMON.SELECTED' | translate }}
            </span>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</div>

</div>







  <!-- Close (discret, comme Uniswap) -->
  <button class="close-btn" (click)="closePreview()">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
    {{ 'CLOSE' | translate }}
  </button>
</div>
